import request from '../../../../../helpers/request';

export const changeShowHintsAndOldRequests = async ({
  showOldRequests,
  showHints,
}) => {
  const res = await request.put(
    `/Request/change_show_hints_and_old_requests`,
    { showOldRequests, showHints },
    'При изменении видимости подсказок и старых заявок произошла ошибка'
  );
  return res;
};
